import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	AutocompleteInput,
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	ReferenceInput,
	TextInput
} from 'react-admin';
import { SuccessStoryList } from './SuccessStoryList';
import { SuccessStoryDatagrid } from './SuccessStoryDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { SuccessStory } from './SuccessStory';

export * from './SuccessStory';
export * from './SuccessStoryCreate';
export * from './SuccessStoryDatagrid';
export * from './SuccessStoryEdit';
export * from './SuccessStoryList';
export * from './SuccessStoryShow';

const SuccessStoriesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'featuredImageUrl', header: 'Feature image' },
	{ key: 'title', header: 'Title' },
	{ key: 'description', header: 'Description' },
	{ key: 'gallery', header: 'Gallery' },
	{ key: 'category.name', header: 'Category' },
	{ key: 'createdBy.fullName', header: 'Created by' },
	{ key: 'organization.name', header: 'Organization' }
];

export const SuccessStoriesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: SuccessStory) => entity;

	const successStoriesFilter = [
		<TextInput source="title" alwaysOn label="SEARCH"/>,
		<ReferenceInput
			step={1}
			label="CATEGORY"
			source="categoryId" reference="success-story-categories"
			alwaysOn
		>
			<AutocompleteInput optionText="name"/>
		</ReferenceInput>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('סיפורי הצלחה', exportFields, exportDataMapper)}
				{...props}
				filters={successStoriesFilter}
				bulkActionButtons={<SuccessStoriesBulkActionButtons/>}
				title="SUCCESS_STORIES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <SuccessStoryList/> : <SuccessStoryDatagrid/>}
			</List>
		</Fragment>
	);
};
